/*
 * Copyright (c) 2023 яαvoroηα
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy of
 *  this software and associated documentation files (the "Software"), to deal in
 *  the Software without restriction, including without limitation the rights to
 *  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 *  the Software, and to permit persons to whom the Software is furnished to do so,
 *  subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in all
 *  copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 *  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 *  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 *  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 *  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import Guide from './guide'
import '@styles/main.scss'
import Banner from '@scripts/components/banner'
import Localisation from '@scripts/components/localisation'
import NavStickyAnchors from '@scripts/components/nav-sticky-anchors'
import Cf7Checkbox from '@scripts/constants/cf7Checkbox'
import Contact from '@scripts/components/contact'
import KeyNumbers from '@scripts/components/key-numbers'
import RelationClient from '@scripts/components/relation-client'
import FormPage from '@scripts/components/form-page'
import CustomFilter from './components/custom-filter'

const { DEV } = import.meta.env

document.addEventListener('DOMContentLoaded', () => {
    console.log('[Application] DOM loaded')

    /**
     * Enable guide in dev mode
     */
    DEV && new Guide().start()

    /**
     * Load components
     */
    const bannerElement = document.querySelector('.banner')
    const localisationElement = document.querySelector('.fd-block-localisation')
    const navStickyAnchorsElement = document.querySelector('.nav-sticky-anchors')
    const cf7CheckElements = document.querySelectorAll('.wpcf7-form-control input[type="checkbox"]')
    const contactElement = document.querySelector('.fd-block-contact')
    const keyNumbersElements = document.querySelectorAll('.fd-block-key-numbers')
    const relationClientElement = document.querySelector('.section-relation-client')
    const formPageElements = document.querySelectorAll('.block-core--paragraph')
    const customFilterElements = document.querySelectorAll('.custom-filter')

    if (bannerElement) {
        const banner = new Banner(bannerElement)

        banner.start()
    }

    if (localisationElement) {
        const localisation = new Localisation(localisationElement)

        localisation.start()
    }

    if (navStickyAnchorsElement) {
        const navStickyAnchors = new NavStickyAnchors(navStickyAnchorsElement)
        bannerElement.style.position = 'absolute'

        navStickyAnchors.start()
    }

    if (cf7CheckElements.length) {
        cf7CheckElements.forEach(function (formCheckbox) {
            const formCheck = new Cf7Checkbox(formCheckbox)

            formCheck.start()
        })
    }

    if (contactElement) {
        const contact = new Contact(contactElement)

        contact.start()
    }

    if (keyNumbersElements.length) {
        keyNumbersElements.forEach(function (keyNumbersElt) {
            const keyNumbers = new KeyNumbers(keyNumbersElt)

            keyNumbers.start()
        })
    }

    if (formPageElements.length) {
        formPageElements.forEach(function (formPageElement) {
            const formPage = new FormPage(formPageElement)

            formPage.start()
        })
    }

    if (relationClientElement) {
        const relationClient = new RelationClient(relationClientElement)

        relationClient.start()
    }

    if (customFilterElements.length) {
        customFilterElements.forEach(function (customFilterElement) {
            const customFilter = new CustomFilter(customFilterElement)

            customFilter.start()
        })
    }

    /**
     * Add global event listener
     */
    // window.addEventListener('event', () => {}, false)})
})
